import { Directive, HostBinding, HostListener, Input } from '@angular/core';

import { UrlHelperService } from '../../services/url-helper/url-helper.service';
import { LocationService } from '@callrail/looky/util';

/**
 * Used to link across apps. This directive will attempt to use a router to link
 * instead when possible. When not possible, regular hrefs will be used
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'a[crossAppLink]',
  standalone: false,
})
export class CrossAppLinkDirective {
  @HostBinding('attr.target') @Input() public target!: string;
  @HostBinding() public href!: string;

  /**
   * Should always be an absolute href path to where you want to link to
   *
   * Should have a leading slash `/`
   *
   * ex: `/v2/a/123456/profile/edit/`
   */
  @Input() set crossAppLink(value: string) {
    this._crossAppLink = value;
    // this updates the link preview when hovering over the link
    this.href = value;
  }

  get crossAppLink(): string {
    return this._crossAppLink;
  }

  private _crossAppLink: string;

  constructor(private urlService: UrlHelperService) {}

  @HostListener('click', [
    '$event.button',
    '$event.ctrlKey',
    '$event.metaKey',
    '$event.shiftKey',
  ])
  public onClick(
    button: number,
    ctrlKey: boolean,
    metaKey: boolean,
    shiftKey: boolean
  ): boolean {
    if (button !== 0 || ctrlKey || metaKey || shiftKey) {
      return true;
    }

    if (typeof this.target === 'string' && this.target !== '_self') {
      return true;
    }

    this.urlService.navigateToPath(this.crossAppLink);
    return false;
  }
}
